import React from "react";

function EndScreen({ userPoints, totalScore, handleRestart }) {
  let emoji;
  const percentage = (userPoints / totalScore) * 100;

  if (percentage === 100) emoji = "🎉";
  if (percentage >= 80 && percentage < 100) emoji = "🚀";
  if (percentage >= 50 && percentage < 80) emoji = "💪";
  if (percentage >= 0 && percentage < 50) emoji = "🤨";
  if (percentage === 0) emoji = "🤦‍♂️";

  return (
    <>
      <p className="result">
        <span>{emoji}</span> You scored <strong>{userPoints}</strong> out of{" "}
        {totalScore} ({Math.ceil(percentage)}%)
      </p>

      <button className="btn-start " onClick={handleRestart}>
        Restart quiz
      </button>
    </>
  );
}

export default EndScreen;
